<div *ngIf="showDialog" class="session-timeout-backdrop">
  <div class="session-timeout-dialog">
    <div *ngIf="!expired">
      <div class="session-timeout-title">{{ translateServ.dictionary['SESSION_SOON_EXP'] }}</div>
      <div class="session-timeout-message">
        {{ translateServ.dictionary['SESSION_CONTINUE'] }} <b>{{ translateServ.dictionary['SESSION_I_AM_HERE'] }}</b> <br />
        <span class="countdown">{{ secondsLeft }} {{ translateServ.dictionary['SEC'] }}</span>
      </div>
      <button class="session-timeout-btn" (click)="onContinue()">{{ translateServ.dictionary['SESSION_I_AM_HERE'] }}</button>
    </div>
    <div *ngIf="expired">
      <div class="session-timeout-title">{{ translateServ.dictionary['SESSION_EXPIRED'] }}</div>
      <div class="session-timeout-message">{{ translateServ.dictionary['SESSION_EXPIRED_MSG'] }}</div>
      <button class="session-timeout-btn" (click)="onRejoin()">{{ translateServ.dictionary['SESSION_REJOIN'] }}</button>
    </div>
  </div>
</div>
